import { gql, useSubscription } from '@apollo/client'

const subscription = gql`
   subscription onNoteUpdated($noteId: ID!, $withContent:Boolean = false) {
      noteUpdated(noteId: $noteId) {
         id
         locked
         lockedByCurrentConnection
         title @include(if: $withContent)
      }
   }
`

const useOnNoteUpdated = (variables, options = {}) => {
   const { data, ...otherSubscriptionResults } = useSubscription(subscription, {
      variables,
      ...options
   })

   return {
      data,
      ...otherSubscriptionResults
   }
}

export default useOnNoteUpdated
